import React from "react";
import styles from "./styles";
import { connect } from "react-redux";
import { Container, Typography, Tooltip } from "@material-ui/core";
import * as actionsPresentacion from "../../../../actions/nuevaPresentacion";
import BtnAdjuntar from "../../../Presentacion/Adjuntos/BtnAdjuntarArchivos";
import ListadoArchivos from "../../../Presentacion/Adjuntos/ListadoArchivos";

const imagenesAsociadas = (props) => {
    const classes = styles();

    const { imagenesFiles, pathTemporal } = props;

    if (
        !props.prestadorSeleccionado ||
        props.tipoPresentacionSeleccionada === "" || 
        props.tipoComprobanteSeleccionado === 3 
    ) {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.container}>
            <Container
                disableGutters={true}
                className={classes.containerTitulo}
            >
                <Typography className={classes.tituloSeccion}>
                    Imagenes asociadas{" "}
                    {props.requeridos.imagenes.requerido ? "*" : ""}
                </Typography>
                <Tooltip
                    placement="right"
                    title={
                        <>
                            <strong>DOCUMENTACION RESPALDATORIA</strong>
                            <br />
                            Extensiones permitidas: "PDF"
                            <br />
                            Extensiones opcionales: "JPG", "JPEG", "PNG", "DOC", "DOCX", "XLSX", y "XLS"
                        </>
                    }
                >
                    <Typography className={classes.ayuda}>?</Typography>
                </Tooltip>
            </Container>
            <Container disableGutters={true} className={classes.filaInputs}>
                <BtnAdjuntar
                    extensionesAceptadas=".jpg,.jpeg,.png,.pdf,.xlsx,.xls,.doc,.docx"
                    multiplesArchivos={true}
                    path={pathTemporal}
                    seccion="imagenes"
                    archivosHandler={props.actualizarImagenesFiles}
                    archivosSubidos={imagenesFiles}
                    deshabilitado={props.soloVista}
                />
            </Container>
            <Container disableGutters={true} className={classes.filaInputs}>
                <ListadoArchivos
                    deshabilitado={props.soloVista}
                    archivosSubidos={imagenesFiles}
                    archivosHandler={props.actualizarImagenesFiles}
                    seccion="imagenes"
                />
                {props.soloVista && imagenesFiles.length === 0 && (
                    <Typography
                        variant="caption"
                        color="primary"
                        align="center"
                        display="block"
                        style={{ fontWeight: "400" }}
                    >
                        No hay archivos cargados en esta sección
                    </Typography>
                )}
            </Container>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
    imagenesFiles: state.nuevaPresentacionReducer.imagenesFiles,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    prestadorSeleccionado: state.nuevaPresentacionReducer.prestadorSeleccionado,
    tipoPresentacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
    tipoComprobanteSeleccionado:
        state.nuevaPresentacionReducer.tipoComprobantesSeleccionado,
    requeridos: state.nuevaPresentacionReducer.requeridos
});

const actionCreators = {
    actualizarImagenesFiles: actionsPresentacion.actualizarImagenesFiles,
};

export default connect(mapStateToProps, actionCreators)(imagenesAsociadas);
